import styled from 'styled-components';
import { toRem } from '.';

export type PositionAt = 'topLeft' | 'top' | 'topRight' | 'right' | 'bottomRight' | 'bottom' | 'bottomLeft' | 'left' | 'center';

const x = (at: PositionAt) => {
    if (at === 'topLeft' || at === 'left' || at === 'bottomLeft') return 'flex-start';
    if (at === 'topRight' || at === 'right' || at === 'bottomRight') return 'flex-end';
    return 'center';
};

const y = (at: PositionAt) => {
    if (at === 'topLeft' || at === 'top' || at === 'topRight') return 'flex-start';
    if (at === 'bottomLeft' || at === 'bottom' || at === 'bottomRight') return 'flex-end';
    return 'center';
};

export interface PositionProps {
    at: PositionAt;
    flow?: 'row' | 'column';
    inset?: number | string;
    zIndex?: number | string;
}

export const Position = styled.div<PositionProps>`
    position: absolute;
    top: ${p => toRem(p.inset ?? 0)};
    left: ${p => toRem(p.inset ?? 0)};
    right: ${p => toRem(p.inset ?? 0)};
    bottom: ${p => toRem(p.inset ?? 0)};
    display: flex;
    flex-direction: ${p => p.flow ?? 'row'};
    justify-content: ${p => (p.flow ?? 'row') === 'row' ? x(p.at) : y(p.at)};
    align-items: ${p => (p.flow ?? 'row') === 'row' ? y(p.at) : x(p.at)};
    ${p => p.zIndex === undefined ? '' : `z-index: ${p.zIndex}`};

    pointer-events: none;
    & > * {
        pointer-events: initial;
    }
`;
